import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getDatabase, ref, get, set, remove, onValue, update,push } from "firebase/database";
import app from "../../../firebaseConfig";
import { Modal, Box, Typography, IconButton, Card, CardContent, Button, TextField, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import ReceiptIcon from "@mui/icons-material/Receipt"; // Icono de Factura
import CloseIcon from "@mui/icons-material/Close"; // Icono de Cerrar
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart"; // Icono de Carrito

import Alertadenegado from "../alertadenegado"; 

function ResumenPedidos() {
  
  const navigate = useNavigate(); // Hook para navegar entre páginas
  const location = useLocation();
  const [productos, setProductos] = useState([]);
  const { mesa, empleado, nota } = location.state || {}; // Obtener valores del estado
  const [open, setOpen] = useState(false); // Controla el modal

  const [nombreTitular, setNombreTitular] = useState(() => {
    return localStorage.getItem("titularpedido") || "";
  });
  const [correoCliente, setCorreoCliente] = useState(() => {
    return localStorage.getItem("correocliente") || "";
  });
  const [correoValido, setCorreoValido] = useState(true);
  const [codigoMesa, setCodigoMesa] = useState("");
  const [codigoIngresado, setCodigoIngresado] = useState("");
  const [openDialog, setOpenDialog] = useState(false);

  const [notaEditable, setNotaEditable] = useState(() => {
    return localStorage.getItem("notaEditablePedido") || "";
  });
  

   const [denegado, setDenegado] = useState(false);

   const [tarifaEnvio, setTarifaEnvio] = useState(0);
   const [umbralGratis, setUmbralGratis] = useState(0);
   
   
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);



// Cargar carrito y valores de envío
useEffect(() => {
  const carritoGuardado = localStorage.getItem("carrito");
  if (carritoGuardado) {
    const data = JSON.parse(carritoGuardado);
    console.log("Carrito cargado desde localStorage:", data);
    setProductos(data);
  } else {
    console.log("No hay carrito guardado en localStorage");
  }

  const db = getDatabase(app);
  const envioRef = ref(db, "nature/Awoo/Control/Envio/Tarifa");
  const gratisRef = ref(db, "nature/Awoo/Control/Envio/Gratis");

  get(envioRef).then((snapshot) => {
    if (snapshot.exists()) {
      setTarifaEnvio(parseInt(snapshot.val()) || 0);
    }
  });

  get(gratisRef).then((snapshot) => {
    if (snapshot.exists()) {
      setUmbralGratis(parseInt(snapshot.val()) || 0);
    }
  });
}, []);

//Esto sirve para monitorear si realmente se está actualizando bien el carrito
useEffect(() => {
  console.log("Productos en el carrito ACTUALIZADOS:", productos);
}, [productos]);


  useEffect(() => {
    const db = getDatabase();
    const codigoRef = ref(db, "nature/Awoo/Control/CodigoMesas");
    get(codigoRef).then((snapshot) => {
      if (snapshot.exists() && snapshot.val().trim() !== "") {
        setCodigoMesa(snapshot.val().trim());
      }
    });
  }, []);

  //////// Esto detecta ancho de la pantalla automaticamente para 1 o 2 columnas
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  /////////////
  

      ////////////////// 🚫 Si el acceso está denegado, solo muestra el AlertDialog
      if (denegado) {
        return (
          <Alertadenegado
            open={true}
            onClose={() => {
              setDenegado(false);
              navigate(-1); // Regresa a la página anterior o redirige donde necesites
            }}
          />
        );
      }
      ///////////////////////////

      

      
  const enviarPedido = async () => {
    navigate("/3dfyrioncheckout", { state: { mesa } });
  };

  const validarCorreo = (correo) => {
    if (!correo) return true; // Si está vacío, es válido (porque es opcional)
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(correo);
  };
  const handleConfirmar = () => {
    if (!nombreTitular.trim()) {
      alert("Debes ingresar un nombre para el titular del pedido.");
      return;
    }
    if (!correoValido) {
      alert("Por favor, ingresa un correo electrónico válido.");
      return;
    }
    if (codigoMesa) {
      setOpenDialog(true);
    } else {
      enviarPedido();
    }
  };
 // Función para aumentar la cantidad de un producto
 const aumentarCantidad = (index) => {
  const nuevosProductos = [...productos];
  nuevosProductos[index].cantidad = (nuevosProductos[index].cantidad || 1) + 1;
  setProductos(nuevosProductos);
  localStorage.setItem("carrito", JSON.stringify(nuevosProductos)); // Guardar cambios
};
// Función para disminuir la cantidad de un producto
const disminuirCantidad = (index) => {
  const nuevosProductos = [...productos];
  if (nuevosProductos[index].cantidad > 1) {
    nuevosProductos[index].cantidad -= 1;
    setProductos(nuevosProductos);
    localStorage.setItem("carrito", JSON.stringify(nuevosProductos)); // Guardar cambios
  }
};
// Función para eliminar un producto con confirmación
const eliminarProducto = (index) => {
    const confirmar = window.confirm("¿Estás seguro de que deseas eliminar este producto?");
    if (confirmar) {
      const nuevosProductos = productos.filter((_, i) => i !== index);
      setProductos(nuevosProductos);
      localStorage.setItem("carrito", JSON.stringify(nuevosProductos)); // Guardar cambios
    }
  };
const verificarCodigo = () => {
    if (codigoIngresado === codigoMesa) {
      setOpenDialog(false);
      enviarPedido();
    } else {
      alert("Código incorrecto. Inténtalo nuevamente.");
    }
  };
// Mostrar resumen del pedido en un alert
const mostrarResumenPedido = () => {
    if (productos.length === 0) {
      alert("El carrito está vacío.");
      return;
    }

    let resumen = `📌 Mesa: ${mesa || "Sin número"}\n\n`;

    productos.forEach((producto) => {
      const subtotal = (producto.Precio || 0) * (producto.cantidad || 1);
      resumen += `🛒 ${producto.Titulo}\n`;
      resumen += `   Cantidad: ${producto.cantidad || 1}\n`;
      resumen += `   Total: $${subtotal.toLocaleString("es-CO")}\n\n`;
    });

    resumen += `💰 Total del Pedido: $${calcularTotal()}`;
    
    alert(resumen);
  };
// Calcular el total del pedido
const calcularTotal = () => {
  const total = productos.reduce(
    (total, producto) => total + (producto.Precio || 0) * (producto.cantidad || 1),
    0
  );



 


  return total.toLocaleString("es-CO"); // Formatea el total con puntos como separadores de 

};




/// Funciones de Calculo
const calcularCantidadProductos = () => {
  return productos.reduce((acc, item) => acc + parseInt(item.cantidad), 0);
};

const calcularSubtotalProductos = () => {
  return productos.reduce(
    (acc, item) => acc + parseInt(item.cantidad) * parseInt(item.Precio),
    0
  );
};


   ///// Calculos adicionales para costos
   const subtotal = calcularSubtotalProductos();
   const envioGratisDisponible = subtotal >= umbralGratis;
   const envioActual = envioGratisDisponible ? 0 : tarifaEnvio;
   
const calcularTotalConEnvio = () => subtotal + envioActual;
   const porcentajeEnvio = Math.min((subtotal / umbralGratis) * 100, 100);
   const restante = Math.max(umbralGratis - subtotal, 0);
   
     //////////////////////////////////////////////////







  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "92vh",
        background: "#000",
        padding: "15px",
      }}
    >
{/* --- Contenedor del título "Carrito de COmpras" --- */}
<div style={{ position: "relative", marginBottom: "15px" }}>

  {/* --- CardView del título Resumen --- */}
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "10px",
      backgroundColor: "#08f9f5",
      borderRadius: "10px",
      boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)",
    }}
  >
    <strong style={{ fontSize: "17px", color: "#000" }}>🛒 Carrito de compras</strong>
  </div>

</div>


<div
  style={{
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    gap: "20px",
    padding: "20px",
  }}
>
  {/* 🟣 Columna izquierda */}
  <div style={{ flex: 1, minWidth: "300px" }}>
    {/* Contenedor de Pedidos */}
    <div
      style={{
        backgroundColor: "#111",
        borderRadius: "15px",
        padding: "15px",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.3)",
        overflowY: "auto",
        height:"360px"
      }}
    >
      {/* ...contenido de pedidos... */}
      {productos.length === 0 ? (
  <p style={{ color: "#aaa", textAlign: "center" }}>
    (No hay productos en el carrito)
  </p>
) : (
  productos.map((producto, index) => (
    <div
      key={index}
      style={{
        position: "relative", // Necesario para posicionar el botón de eliminar
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: "#fff",
        borderRadius: "15px",
        padding: "10px",
        border: "3px solid #02f2fa",
        boxShadow: "0 0 10px rgba(2, 242, 250, 0.7)",
        marginBottom: "10px",
        cursor: "pointer",
      }}
    >
      {/* Botón de eliminar */}
      <button
        style={{
          position: "absolute",
          top: "-10px",
          left: "-10px",
          backgroundColor: "red",
          color: "white",
          border: "none",
          borderRadius: "50%",
          width: "25px",
          height: "25px",
          fontSize: "14px",
          cursor: "pointer",
          boxShadow: "0px 2px 5px rgba(0,0,0,0.3)",
        }}
        onClick={() => eliminarProducto(index)}
      >
        ✖
      </button>


{/* Contenedor de imagen y descuento */}
<div style={{ position: "relative", width: "80px", height: "80px", marginBottom: "20px" }}>
  {/* Imagen del producto */}
  <img
    src={producto.Img || "images/default.jpg"}
    alt={""}
    style={{
      width: "80px",
      height: "80px",
      objectFit: "cover",
      borderRadius: "50%",
    }}
  />

  {/* Descuento sobresaliendo */}
  {producto.PrecioAnterior > producto.Precio && (
    <div
      style={{
        position: "absolute",
        bottom: "-12px",
        left: "50%",
        transform: "translateX(-50%)",
        backgroundColor: "#b016b5",
        color: "#fff",
        padding: "4px 8px",
        borderRadius: "6px",
        fontSize: "12px",
        fontWeight: "bold",
        whiteSpace: "nowrap",
        boxShadow: "0px 2px 5px rgba(0,0,0,0.2)",
      }}
    >
      -{Math.round(100 - (producto.Precio * 100) / producto.PrecioAnterior)}% OFF
    </div>
  )}
</div>





      {/* Contenedor de título y precio */}
      <div style={{ flex: 1, marginLeft: "10px" }}>
        <div style={{ color: "black", fontWeight: "bold" }}>
          {producto.Titulo || ""}
        </div>
        <div style={{ color: "#5b5b5b", fontWeight: "bold", marginTop:"3px" }}>
          {producto.Tipovariante}:{" " + producto.variante?.Nombre} 
        </div>

        <div style={{ marginTop: "5px" }}>
  {/* Precio anterior tachado */}
  {producto.PrecioAnterior && (
    <div
      style={{
        backgroundColor: "#fff",
        color: "#999",
        padding: "5px",
        borderRadius: "10px",
        fontWeight: "bold",
        fontSize: "13px",
        display: "inline-block",
        textDecoration: "line-through",
      }}
    >
      ${producto.PrecioAnterior.toLocaleString("es-CO")}
    </div>
  )}

  {/* Precio actual */}
  <div
    style={{
      marginTop: "5px",
      backgroundColor: "#e27f0e",
      color: "white",
      padding: "5px",
      borderRadius: "10px",
      fontWeight: "bold",
      fontSize: "14px",
      display: "inline-block",
    }}
  >
    ${producto.Precio?.toLocaleString("es-CO") || "0"}
  </div>

       </div>


{/* Botones Cantidad */}
<div style={{ display: "flex", justifyContent: "flex-end", marginTop: "5px", marginRight:"15px" }}>
  <div style={{ color: "#5b5b5b", fontWeight: "bold", textAlign: "right" }}>
    <div style={{ color: "black", fontWeight: "bold" , marginRight:"10px"}}>
      {"Cantidad"}
    </div>
    
    {/* Botones para aumentar y disminuir cantidad */}
    <div>
      <button
        style={{
          backgroundColor: "#ff4d4d",
          color: "white",
          border: "none",
          borderRadius: "50%",
          width: "30px",
          height: "30px",
          fontSize: "18px",
          cursor: "pointer",
        }}
        onClick={() => disminuirCantidad(index)}
      >
        -
      </button>
      <span style={{ margin: "0 10px", fontWeight: "bold" }}>
        {producto.cantidad || 1}
      </span>
      <button
        style={{
          backgroundColor: "#4caf50",
          color: "white",
          border: "none",
          borderRadius: "50%",
          width: "30px",
          height: "30px",
          fontSize: "18px",
          cursor: "pointer",
        }}
        onClick={() => aumentarCantidad(index)}
      >
        +
      </button>
    </div>
  </div>
</div>



      </div>

      
    </div>
  ))
)}
    </div>

    {/* 🚚 Progreso hacia Envío Gratis */}
    <div
      style={{
        backgroundColor: "#222",
        borderRadius: "12px",
        padding: "12px 15px",
        marginTop: "20px",
        marginBottom: "10px",
      }}
    >
      {/* ...progreso... */}
        {/* Fila: Envío + Tarifa */}
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "8px",
    }}
  >
    <span style={{ fontSize: "14px", color: "#fff" }}>Envío</span>
    <span
      style={{
        fontSize: "14px",
        fontWeight: "bold",
        color: envioGratisDisponible ? "green" : "#fff",
        textDecoration: envioGratisDisponible ? "line-through" : "none",
      }}
    >
      ${tarifaEnvio?.toLocaleString("es-CO") }
    </span>
  </div>

  {/* Barra de progreso */}
  <div
    style={{
      height: "10px",
      width: "100%",
      backgroundColor: "#444",
      borderRadius: "5px",
      overflow: "hidden",
      marginBottom: "6px",
    }}
  >
    <div
      style={{
        height: "100%",
        width: `${porcentajeEnvio}%`,
        backgroundColor: envioGratisDisponible ? "#4caf50" : "#08f9f5",
        transition: "width 0.3s ease-in-out",
      }}
    ></div>
  </div>

  {/* Texto bajo la barra */}
  <span
    style={{
      fontSize: "13px",
      color: envioGratisDisponible ? "#4caf50" : "#ccc",
      fontWeight: "bold",
    }}
  >
    {envioGratisDisponible
      ? "🎉 ¡Aprovecha tu envío gratis agregando más productos!"
      : `Agrega $${restante?.toLocaleString("es-CO") } más para conseguir envío gratis`}
  </span>
    </div>
  </div>

  {/* 🟢 Columna derecha */}
  <div style={{ flex: 1, minWidth: "300px" }}>
    {/* 🧾 Resumen de pago */}
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#222",
        borderRadius: "12px",
        padding: "10px 15px",
      }}
    >
      {/* ...resumen... */}
        {/* Fila: Productos */}
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "8px",
    }}
  >
    <span style={{ fontSize: "14px", color: "#fff" }}>
      Productos ({calcularCantidadProductos()})
    </span>
    <span
      style={{
        color: "#fff",
        fontWeight: "bold",
        fontSize: "14px",
      }}
    >
      ${subtotal?.toLocaleString("es-CO") }
    </span>
  </div>

  {/* Fila: Envío */}
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "8px",
    }}
  >
    <span style={{ fontSize: "14px", color: "#fff" }}>Envío</span>
    <span
      style={{
        fontSize: "14px",
        fontWeight: "bold",
        color: envioGratisDisponible ? "green" : "#fff",
      }}
    >
      {envioGratisDisponible ? "GRATIS" : `$${tarifaEnvio?.toLocaleString("es-CO") }`}
    </span>
  </div>

  {/* Fila: Total */}
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      borderTop: "1px solid #444",
      paddingTop: "10px",
      marginTop: "10px",
    }}
  >
    <span style={{ fontSize: "15px", color: "#fff" }}>Costo Total:</span>
    <span
      style={{
        backgroundColor: "#08f9f5",
        padding: "6px 12px",
        borderRadius: "8px",
        color: "#000",
        fontWeight: "bold",
        fontSize: "15px",
      }}
    >
      ${calcularTotalConEnvio()?.toLocaleString("es-CO") }
    </span>
  </div>
    </div>

    {/* Botón de Enviar Pedido */}
    <button
      onClick={enviarPedido}
      startIcon={<ShoppingCartIcon />}
      style={{
        marginTop: "10px",
        padding: "8px",
        backgroundColor: "#87e310",
        color: "#000",
        fontSize: "18px",
        fontWeight: "bold",
        borderRadius: "10px",
        border: "none",
        cursor: "pointer",
        transition: "0.3s",
      }}
      onMouseOver={(e) => (e.target.style.backgroundColor = "#26e3e0")}
      onMouseOut={(e) => (e.target.style.backgroundColor = "#87e310")}
    >
      🚀 Continuar Compra
    </button>
  </div>
</div>








      {/* MODAL DE RESUMEN DE PEDIDO */}
      <Modal open={open} onClose={() => setOpen(false)}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 300,
          maxHeight: "90vh",
          overflowY: "auto",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 3,
          borderRadius: "10px",
        }}
      >
        {/* ENCABEZADO */}
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" fontWeight="bold">
            <ReceiptIcon sx={{ verticalAlign: "middle", color: "blue" }} /> Resumen de la Orden
          </Typography>
          <IconButton onClick={() => setOpen(false)}>
            <CloseIcon color="error" />
          </IconButton>
        </Box>

        {/* MESA */}
        <Typography variant="subtitle1" fontWeight="bold" color="gray">
          Mesa: {mesa || "Sin número"}
        </Typography>


        <Typography fontWeight="bold">{"Ingresa un Titular del Pedido"}</Typography>
        {/* CAMPOS ADICIONALES */}
        <TextField
          fullWidth
          label="El pedido a nombre de:"
          variant="outlined"
          margin="normal"
          required
          value={nombreTitular}
          onChange={(e) => {
            const nombreTitular = e.target.value;
            setNombreTitular(nombreTitular);
            localStorage.setItem("titularpedido", nombreTitular); // 👈 Guardamos en localStorage
          }}
          
        />


        {/* LISTA DE PRODUCTOS */}
        {productos.length === 0 ? (
          <Typography color="gray" textAlign="center">
            (No hay productos en el carrito)
          </Typography>
        ) : (
          productos.map((producto, index) => (
            <Card key={index} sx={{ my: 1, backgroundColor: "#c9ffc9" }}>
              <CardContent>
                <Typography fontWeight="bold">{producto.Titulo}</Typography>
                <Typography variant="body2" color="text.secondary">
                  Cantidad: {producto.cantidad || 1} | Precio unitario: ${producto.Precio?.toLocaleString("es-CO")}
                </Typography>
                <Typography fontWeight="bold" color="green">
                  Total: ${((producto.Precio || 0) * (producto.cantidad || 1)).toLocaleString("es-CO")}
                </Typography>
              </CardContent>
            </Card>
          ))
        )}

        {/* TOTAL FINAL */}
        <Typography variant="h6" fontWeight="bold" color="black" mt={2}>
          💰 Total del Pedido: ${calcularTotal()}
        </Typography>

{/* NOTA PARA COCINA O BAR */}
{notaEditable && (
  <Box mt={2} p={2} bgcolor="#fff3cd" borderRadius="10px" border="1px solid #ffeeba">
    <Typography variant="subtitle2" fontWeight="bold" color="#856404" gutterBottom>
      📝 Nota para Cocina o Bar:
    </Typography>
    <Typography variant="body2" color="#856404">
      {notaEditable}
    </Typography>
  </Box>
)}



        <Typography variant="body2" color="gray" mb={1}>
          {/* ESPACIADO */}
        </Typography>
        <Typography variant="body2" color="gray" mb={1}>
          {/* ESPACIADO 2 */}
        </Typography>
       

        <Typography variant="body2" color="gray" mb={1}>
          Puedes ingresar tu correo para registrarte como cliente recurrente.
        </Typography>
        <TextField
          fullWidth
          label="Correo electrónico (opcional)"
          variant="outlined"
          margin="normal"
          value={correoCliente}
          onChange={(e) => {
            const correoCliente = e.target.value;
            setCorreoCliente(correoCliente);
            setCorreoValido(validarCorreo(e.target.value));
            localStorage.setItem("correocliente", correoCliente); // 👈 Guardamos en localStorage
          }}
          error={!correoValido}
          helperText={!correoValido ? "Correo electrónico inválido" : ""}
        />

        {/* BOTÓN DE CONFIRMAR */}
        <Button
          variant="contained"
          color="primary"
          fullWidth
          sx={{ mt: 2, borderRadius: "10px" }}
          onClick={handleConfirmar}
          disabled={!nombreTitular.trim() || !correoValido}
        >
          Confirmar Pedido
        </Button>
      </Box>


    </Modal>

    {openDialog && (
  <Modal open={openDialog} onClose={() => setOpenDialog(false)}>
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 300,
        bgcolor: "background.paper",
        boxShadow: 24,
        p: 3,
        borderRadius: "10px",
      }}
    >
      <Typography variant="h6" fontWeight="bold">
        Seguridad Adicional
      </Typography>
      <Typography>Ingresa el código de la pantalla</Typography>
      <TextField
        fullWidth
        margin="dense"
        variant="outlined"
        value={codigoIngresado}
        onChange={(e) => setCodigoIngresado(e.target.value)}
      />
      <Box display="flex" justifyContent="space-between" mt={2}>
        <Button onClick={() => setOpenDialog(false)} color="secondary">
          Cancelar
        </Button>
        <Button onClick={verificarCodigo} color="primary">
          Validar
        </Button>
      </Box>
    </Box>
  </Modal>
)}



    </div>
  );
}

export default ResumenPedidos;
